<!-- eslint-disable -->
<template>
  <CommonPages id="about-us" :class="['about-us-page']" :titlePrefix="'About Us'"
    :metaDescription="domainConfig?.['meta']?.des || 'Learn more about us and our mission'">
    <div class="about-us-full">
      <div class="about-us-full__container">
        <div class="about-us-full__content">
          <div class="about-us-full__title-container">
            <div class="about-us-full__title">About Us</div>
          </div>
          <div class="about-us-full__description">
            At {{ domainConfig?.IAmURL }}, we believe that a name is more than just a label—it's a
            gift, a story, and the first step in a lifetime journey. Our mission is to help parents
            around the world find meaningful, beautiful, and culturally rich names for their little
            ones using the power of advanced AI technology.
            <br /><br />
            We understand that choosing a baby’s name can be both exciting and overwhelming. That’s
            why we’ve created an intelligent, user-friendly platform that blends linguistic data,
            cultural traditions, and modern trends to generate name suggestions tailored to your
            preferences. Whether you're looking for something classic, unique, international, or
            symbolic, {{ domainConfig?.IAmURL }} is here to inspire you with thoughtful options.
            <br /><br />
            Our AI engine analyzes thousands of names across various languages, origins, and
            meanings
            to offer personalized recommendations based on your selected criteria—such as gender,
            style, heritage, initials, and more. Every name we suggest is carefully curated to
            ensure
            it carries significance and charm.
            <br /><br />
            At {{ domainConfig?.IAmURL }}, we’re not just about names—we’re about identity,
            connection, and the stories that begin at birth. Join thousands of families who’ve
            already
            found their perfect baby name with us.
            <br /><br />
            Start your naming journey today with {{ domainConfig?.IAmURL }}—where tradition meets
            technology, and every name is a step into the future.
          </div>
        </div>
      </div>
    </div>
  </CommonPages>
</template>

<script>
import common from '@/mixin/common.js'
import adMixin from '@/mixin/adMixin.js'
import adTrackingMixin from '@/mixin/adTrackingMixin.js'
import { mapGetters } from 'vuex';
import CommonPages from '@/pages/components/page_common.vue'

import '@/css/common.scss';

export default {
  name: 'AboutUs',
  components: {
    CommonPages
  },
  mixins: [common, adMixin, adTrackingMixin],
  computed: {
    ...mapGetters([
      "adsensConfig",
      'adPosConfig',
      'deviceType',
      'domainConfig',
    ]),
  },
  async activated () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[AboutUs] Component activated`);
    }
  },
  async mounted () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[AboutUs] Component mounted`);
    }
  },
  deactivated () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[AboutUs] Component deactivated`);
    }
  },
  beforeDestroy () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[AboutUs] Component beforeDestroy`);
    }
  },
  methods: {

  }
};
</script>

<style lang="scss">
@import '@/css/variables.scss';
</style> 

<style lang="scss" scoped>
@import '@/css/variables.scss';

.about-us-page {
}

.about-us-full {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: flex-start;
	align-self: stretch;
	position: relative;
	width: 100%;
	background: linear-gradient(180deg, #000 0%, rgba(0, 0, 0, 0) 50%, #191919 100%), linear-gradient(0deg, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0.6) 100%), linear-gradient(93deg, #08f 0%, #e54cba 50%, #c8ad17 100%);

	&__container {
		width: 100%;
		min-height: rem(800);
		position: relative;
		overflow: hidden;
	}

	&__background {
		width: 100%;
		height: 100%;
		position: absolute;
		left: 0;
		top: 0;
	}

	&__bg-image {
		width: 100%;
		height: 100%;
		position: absolute;
		left: 0;
		top: 0;
		object-fit: cover;
	}

	&__bg-overlay {
		width: 100%;
		height: 100%;
		position: absolute;
		left: 0;
		top: 0;
	}

	&__content {
		display: flex;
		flex-direction: column;
		gap: rem(36);
		align-items: flex-start;
		justify-content: flex-start;
		padding: rem(80) rem(180) 0;
		position: relative;
		z-index: 1;
	}

	&__title-container {
		display: flex;
		flex-direction: column;
		gap: rem(16);
		align-items: center;
		justify-content: flex-start;
		position: relative;
	}

	&__title {
		color: #fff;
		font-size: rem(24);
		font-style: normal;
		font-weight: 500;
		line-height: rem(24); /* 100% */
	}

	&__description {
		color: #fff;
		text-align: left;
		font-size: rem(16);
		line-height: rem(28);
		font-weight: 400;
		position: relative;
		align-self: stretch;
	}
}

// PC端基础样式
.detect_deviece_pc,
.detect_deviece_desktop {
	.about-us-full {
		// PC端特定样式
	}
}

// 移动端基础样式
.detect_deviece_mobile {
	.about-us-full {
		padding: rem(40) rem(16);

		&__container {
			min-height: rem(600);
		}

		&__content {
			width: 100%;
			padding: 0;
		}

		&__title {
			font-size: rem(28);
			line-height: rem(28);
		}

		&__description {
			font-size: rem(14);
			line-height: rem(24);
			text-align: left;
		}
	}
}
</style>